import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { SettlementsService } from 'src/app/services/settlements.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-offcanvas-navbar',
  template: `
    <div class="offcanvas-header">
      <h5 class="offcanvas-title text-light" id="offcanvasDarkNavbarLabel">Menú</h5>
      <button type="button" class="btn-close btn-close-black" data-bs-dismiss="offcanvas" aria-label="Close" (click)="dismiss()"></button>
    </div>
    <div class="offcanvas-body">
      <div class="ms-auto text-end">
      </div>
      
      <ul class="nav nav-pills flex-column mb-auto mt-3" *ngIf="permissionsLS">
        <li >
          <a #dashboard routerLink="dashboard" class="nav-link link-light d-flex active" (click)="navigate($event)">
            <div>
              <img src="assets/images/icon-reports.svg" width="18px">
            </div>
            <div class="flex-fill">
              <span class="mt-0 ms-3">Resumen general</span>
            </div>
          </a>
        </li>

        <li *ngIf="authService.hasPermission('can_read_settlements')">
          <a #clients routerLink="condominios/{{user?.settlement_id}}" class="nav-link link-light d-flex" (click)="navigate($event)">
            <div>
              <img src="assets/images/icon-building.png" class="float-start" style="width: 20px;">
            </div>
            <div class="flex-fill">
              <span class="mt-0 ms-3">Condominios y comercial</span>
            </div>
          </a>
        </li>

        <li *ngIf="authService.hasPermission('can_read_fuel')">
          <a routerLink="combustibles/tanques" class="nav-link link-light d-flex" (click)="navigate($event)">
            <div>
              <img src="assets/images/icon-gas.svg" class="float-start" style="width: 18px;"> 
            </div>
            <div class="flex-fill">
              <span class="mt-0 ms-3">Combustible</span>
            </div>
          </a>
        </li>

        <li *ngIf="authService.hasPermission('can_read_tasks')">
          <a routerLink="maintenances/tasks" class="nav-link link-light d-flex" (click)="navigate($event)">
            <div>
              <img src="assets/images/icon-tasks.svg" class="float-start" style="width: 20px;">
            </div>
            <div class="flex-fill">
              <span class="mt-0 ms-3">Tareas y Técnicos</span>
            </div>
          </a>
        </li>

        <li *ngIf="authService.hasPermission('can_read_reports')">
          <a routerLink="reports" class="nav-link link-light d-flex" (click)="navigate($event)">
            <div>
              <img src="assets/images/icon-reports.svg" class="float-start" style="width: 20px;">
            </div>
            <div class="flex-fill">
              <span class="mt-0 ms-3">Reportes y consumos</span>
            </div>
          </a>
        </li> 
      </ul>
    </div>
  `,
  styles: ``
})
export class OffcanvasNavbarComponent {
  @Input() user: any;
  // @Input() profiles: any;
  // @Output() signOut = new EventEmitter<any>();
  profile: any;
  permissionsLS: any;
  storageService = inject(StorageService);
  constructor(
    // private store: SettlementsService,
    public activeOffcanvas: NgbActiveOffcanvas,    
    public icons: IconsService,
    public authService: AuthService
  ) { 
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissionsLS = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ?? {};
  }

  /*changeProfile(profile: any) {
    this.profile = profile;
    let currProfile = this.profiles.find((el: any) => profile.id == el.id);

    // console.log('currProfile => ', currProfile);

    localStorage.setItem('profile', JSON.stringify({ profile: currProfile}));
    localStorage.removeItem('payFilterPrefs');
    this.store.updateUser(this.user.id, { profile_id: profile.id }).subscribe({
      next: (data: any) => {
        localStorage.setItem('user', JSON.stringify(data));
        window.location.reload();
      }
    });
  }*/

    navigate(e: any, collapse: string = '') {
      console.log('dashboard => ', e.target.closest('a'));
      let link: any = e.target.closest('a');
      // this.dashboard.nativeElement.click();
      // this.sidebar?.nativeElement.querySelectorAll('.nav-link').forEach((el: any) => {
        // // console.log('el => ', el);
        // el.classList.remove('active');
      // });
  
      
  
      // if (collapse) {
        // if (this.sidebar?.nativeElement.querySelector(`#${collapse}`).classList.contains('collapse')) {
          // this.sidebar?.nativeElement.querySelector(`#${collapse}`).classList.remove('collapse')
          // this.sidebar?.nativeElement.querySelector(`#${collapse}`).classList.add('active');
        // } else {
          // this.sidebar?.nativeElement.querySelector(`#${collapse}`).classList.remove('active')
          // this.sidebar?.nativeElement.querySelector(`#${collapse}`).classList.add('collapse');
        // }
      // }
      
      link.classList.add('active');
      this.dismiss();
    }

  dismiss() {
    this.activeOffcanvas.dismiss('Cross click');
  }

  closeSession() {
    // this.signOut.emit();
    this.activeOffcanvas.close();
  }

  // signOut() {}
}
